import Footer from "./components/footer";
import NavBar from "./components/navbar";
import bgImage from "./images/bgimage.jpg";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getGlobalMetaData } from "./ReduxActions/getGlobalData";
import AboutUs from "./pages/aboutus";
import ContactForm from "./components/contactform";
import { ScrollProvider } from "./context/ScrollContext";
import PrivacyPolicy from "./pages/privacy_policy";
import PrivacyPolicyWel from "./pages/privacy_policy_wel";

export default function App() {

  const dispatch = useDispatch();
  const [data, setData] = useState(null);

  const metaData = useSelector((state) => state.globaldata.data);

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(getGlobalMetaData());
      console.log('dis')
    };

    fetchData();
  }, [dispatch]);


  useEffect(() => {
    setData(metaData);
  }, [metaData]);

  console.log(data);


  return (
    <div
      className="w-full bg-cover bg-center relative"
      style={{
        backgroundImage: `linear-gradient(to right, rgba(0,0,0,0.7), rgba(0,0,0,0.7)), url(${bgImage})`,
      }}
    >
      <Router>
        <ScrollProvider>
          {data?.header?.visible && <NavBar content={data.header} />}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
            <Route path="/privacy-policy/wel" element={<PrivacyPolicyWel/>} />
          </Routes>
          {data?.form?.visible && <ContactForm content={data.form.data} />}
          {data?.footer?.visible && <Footer content={data.footer.data} sociallinks={data.links?.socialLinks} />}
        </ScrollProvider>
      </Router>
    </div>
  )
}
